var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-modal',{attrs:{"open":_vm.debug || _vm.active},on:{"close":function($event){return _vm.extend()}}},[_vm._t("default",null,{"ttl":_vm.ttl,"extend":_vm.extend,"end":_vm.end})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }